"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var connected_react_router_1 = require("connected-react-router");
var createPathByFilters_1 = __importDefault(require("../../utils/createPathByFilters"));
var selectors_1 = require("../../selectors");
var track_event_1 = __importDefault(require("../../../../utils/track-event"));
var selectors_2 = require("../../../common/selectors");
var GenericSelect_1 = __importDefault(require("../../../common/GenericSelect"));
var styled_components_1 = __importDefault(require("styled-components"));
var Categories = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var rootPath = (0, react_redux_1.useSelector)(selectors_1.rootPathSelector);
    var isCustomStore = (0, react_redux_1.useSelector)(selectors_2.isCustomStoreSelector);
    var filters = (0, selectors_1.useFiltersSelector)(isCustomStore);
    var disabled = filters.loading, combine = filters.combine;
    var categories = (0, selectors_1.useCategoriesSelector)();
    var tree = categories.createByValue(combine || rootPath);
    var list = categories.transformToFlatList(tree);
    var selects = list.filter(function (options) { return options.length; });
    var handleChange = function (value) {
        var newCombine = "".concat(isCustomStore ? '' : rootPath).concat(value);
        dispatch((0, connected_react_router_1.push)({
            pathname: (0, createPathByFilters_1.default)(filters, {
                combine: newCombine,
                subTag: '',
                page: 1,
            }),
        }));
        (0, track_event_1.default)({
            category: 'filter_tovar',
            action: newCombine,
        });
    };
    var getActiveOptionValue = function (options) {
        return (options.filter(function (option) { return option.active; })[0] || { url: '' }).url;
    };
    return (react_1.default.createElement(Container, null, selects.map(function (options, i) { return (react_1.default.createElement(GenericSelect_1.default, { key: i, label: 'раздел', bordered: true, value: getActiveOptionValue(options), options: options.map(function (option) { return ({
            value: option.url,
            label: option.title,
        }); }), onChange: handleChange, disabled: disabled })); })));
};
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n\n  .generic-select {\n    width: 160px;\n    margin-bottom: 12px;\n    margin-right: 12px;\n  }\n\n  @media (max-width: 940px), (hover: none) {\n    .generic-select {\n      margin-right: 0px;\n      width: 100%;\n    }\n  }\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n\n  .generic-select {\n    width: 160px;\n    margin-bottom: 12px;\n    margin-right: 12px;\n  }\n\n  @media (max-width: 940px), (hover: none) {\n    .generic-select {\n      margin-right: 0px;\n      width: 100%;\n    }\n  }\n"])));
exports.default = Categories;
var templateObject_1;
